const history = require('history');

const createBrowserHistory = history.createBrowserHistory();

export default createBrowserHistory;
